import axios from 'axios'
import { pathOr } from 'ramda'
import URLSearchParams from 'url-search-params'

import scrollTo from 'js/helpers/scrollTo'
import { IsDev } from '../../../helpers/build'
import setValue from './setValue'
import selectRoomAction from './selectRoom'
import openPopup from '../../PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from '../../PopupConstructor/constants'
import toggleGlobalLoader from '../../loader/actions/loaderActions'
import dataLayerPush from '../../../helpers/dataLayerPush'
import {asyncTimeout, containsValue} from '../../../helpers/utils'
import { HOTEL_PAGE_PARAM_ROOM_ID, HOTEL_PAGE_PARAM_RATE_ID, PARAM_CTA_SELECT } from '../constants'
import setUrlParams from '../urlParams'
import { FILTER_DATES } from '../../search/constants'
import filterChange from '../../search/actions/filters/filterChange'

let data = pathOr({}, ['default'], require('./mocks/rooms'))

export const GET_ROOMS_ENDPOINT = pathOr('https://5b3a1a5a356f570014d0baa0.mockapi.io/hotel/1/room',
  ['drupalSettings', 'search', 'api', 'rooms'], window)

export const HOTEL_ID = pathOr(1, 'drupalSettings.rooms.rates.hotelId'.split('.'), window)
export const GET_RATES_ENDPOINT = pathOr(false, 'drupalSettings.search.api.rates'.split('.'), window)

export const getRooms = async (dispatch, getState, queryString, init) => {
  const state = getState();
  dispatch(toggleGlobalLoader(true))
  try {
    dispatch(setValue('roomsLoaded', false))
    if (IsDev) {
      await asyncTimeout(2)
      console.info(`%c GET /hotel/${HOTEL_ID}/rooms from mock data`, 'color: #67a9ad; font-weight: bold;')
    } else {
      const { data: rData } = await axios.get(
        GET_ROOMS_ENDPOINT
        + (queryString || state.main.queryString),
      )
      data = rData
    }
    const prefilledData = pathOr({
      roomId: null,
      roomRateId: null,
    }, ['prefilledData'], data)
    dispatch(setValue('rooms', data.result))
    dispatch(setValue('roomsLoaded', true))
    dispatch(setValue('prefilledData', prefilledData))
    dispatch(setValue('calendarWithError', data.calendarWithError))
    dispatch(setValue('calendarWithoutError', data.calendarWithoutError))

    // if user came to room rates page without dates or
    // available: false we should show dates filter opened
    if (data.calendarWithError || data.calendarWithoutError) {
      dispatch(filterChange('activeFilter', FILTER_DATES))
    }

    if (typeof init === 'boolean' && !init) {
      dataLayerPush(data.dataLayer)
    }

    const {
      result: rooms,
    } = data

    const {
      roomId: prefilledRoomId,
      roomRateId: prefilledRoomRateId,
    } = prefilledData

    const searchParams = new URLSearchParams(window.location.search)
    const paramsRoomId = searchParams.get(HOTEL_PAGE_PARAM_ROOM_ID)
    const paramsRoomRateId = searchParams.get(HOTEL_PAGE_PARAM_RATE_ID)
    const paramCtaSelect = searchParams.get(PARAM_CTA_SELECT)
    const roomIdResultArr = rooms.map(obj => obj.id)
    const toolbarOffset = parseInt(document.querySelector('body').style.paddingTop, 10) || 0
    const $stickyHeader = document.querySelector('.site-header')
    let el = document.querySelector('.apartment-tabset')
    let scrollEl

    let roomId = null
    let roomRateId = null
    let scrollDirection

    /** If no rooms in basket or no rooms in url
     *  select the first one rooms[0].id  rooms[0].roomRates[0].id */
    const isPrefiledInResponse = containsValue(data.result, 'id', prefilledData.roomId)

    if (prefilledRoomId && prefilledRoomId.length && !paramCtaSelect) {
      roomId = isPrefiledInResponse ? prefilledData.roomId : rooms[0].id
      roomRateId = isPrefiledInResponse ? prefilledData.roomRateId : rooms[0].roomRates[0].id
    } else {
      roomId = paramsRoomId || rooms[0].id
      roomRateId = paramsRoomRateId || rooms[0].roomRates[0].id
      searchParams.delete(PARAM_CTA_SELECT)
    }

    if (searchParams.has(HOTEL_PAGE_PARAM_ROOM_ID)) {
      searchParams.delete(HOTEL_PAGE_PARAM_ROOM_ID)
    }

    if (searchParams.has(HOTEL_PAGE_PARAM_RATE_ID)) {
      searchParams.delete(HOTEL_PAGE_PARAM_RATE_ID)
    }

    if (roomId && roomId.length && !!roomIdResultArr.find(id => id === roomId)) {
      searchParams.append(HOTEL_PAGE_PARAM_ROOM_ID, roomId)
      if (roomRateId && roomRateId.length) {
        searchParams.append(HOTEL_PAGE_PARAM_RATE_ID, roomRateId)
      }

      if (searchParams.get('emptyCalendar') !== 'true') {
        setUrlParams(searchParams)
      }

      await dispatch(selectRoomAction(roomId))
      el = document.querySelector(`[data-room-id="${roomId}"]`)
    }

    if (el) {
      setTimeout(() => {
        if (window.innerWidth > 1004) {
          scrollDirection = window.pageYOffset < el.offsetTop ? -130 : -155
        } else if ($stickyHeader.classList.contains('sticky-wrapper-top') || window.pageYOffset === 0) {
          scrollDirection = window.pageYOffset < el.offsetTop ? -130 : -120
        } else {
          scrollDirection = window.pageYOffset < el.offsetTop ? -60 : -55
        }

        let dynamicOffset = scrollDirection - toolbarOffset
        const scrollToRates = window.innerWidth <= 1004
        scrollEl = document.querySelector(`[room_id="${roomId}"]`)

        if (scrollToRates) {
          // dynamicOffset += scrollEl.firstElementChild.offsetHeight
        }

        scrollTo(el, { offset: dynamicOffset, align: 'top', duration: 0 })
      }, 1000)
    }

    dispatch(toggleGlobalLoader(false))
  } catch (e) {
    const error = pathOr({}, ['response', 'data'], e)
    dispatch(toggleGlobalLoader(false))
    if (error.message) {
      dispatch(openPopup(GLOBAL_ERROR_POPUP, error))
    }
  }
}

export default
(queryString = null, init) => (dispatch, getState) => getRooms(dispatch, getState, queryString, init)
